import { render, staticRenderFns } from "./inventory-units.vue?vue&type=template&id=0ec8c1a4"
import script from "./inventory-units.vue?vue&type=script&lang=js"
export * from "./inventory-units.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports